import styled, {css} from 'styled-components';
interface ItemProps {
  readonly color?: string;
  readonly size?: string;
  readonly margin?: string;
}
export const LabelsContainer = styled.div`
  box-sizing: border-box;
  height: 41px;
  width: 189px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 7px;
`;
export const LabelsWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin: 0 50px;
`;
export const KeyScaleWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items:center;
  justify-content: space-between;
  margin-left: 10px;
`;

export const InfoButton = styled.div`
  height:18px;
  width:18px;
  border-radius: 50%;
  margin: 0px 20px 0px 8px;
  background-color: rgba(172,177,192,0.5);
  text-align:center;
  color:white;
  cursor: pointer;
`

export const TableWrapper = styled.div`
  display: flex;
  overflow-x: auto;
  margin: 10px;
  min-height: 290px;
`;

export const Oval = styled.div<ItemProps>`
  border-radius: 50% 50% 50% 50%;
  display: inline-block;
  margin-left: auto;

  ${props => {
    const height = 'min-height:' + props.size + 'px;height:' + props.size + 'px;';
    const width = 'min-width:' + props.size + 'px;width:' + props.size + 'px;';
    const margin = 'margin:' + props.margin + ';';
    let color;
    switch (props.color) {
      case 'yellow':
        color = 'rgba(255,191,86,1)';
        break;
      case 'red':
        color = 'rgba(228,146,255,1)';
        break;
      case 'blue':
        color = 'rgba(0,155,158,1)';
        break;
      case 'green':
        color = 'rgba(149,221,101,1)';
        break;
      default:
        color = 'rgba(81, 227, 99, 1)';
        break;
    }
    const background = 'background:' + color + ';';
    return css`
       {
        ${height}
        ${width}
        ${background}
        ${margin}
      }
    `;
  }};
`;
export const TextContainer = styled.div`
  color: rgba(93, 110, 129, 1);
  font-family: 'Proxima Nova';
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.61px;
  line-height: 12px;
  height: 12px;
  min-width: max-content;
`;
export const AlertContainer = styled.div`
  color: rgba(93, 110, 129, 1);
  font-family: 'Proxima Nova';
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.55px;
  line-height: 9px;
  align-items: center;
`;
export const HideContainer = styled.div`
  display: none;
`;
